module.exports = __webpack_public_path__ + "static/media/senses.40e65931.jpg";